import { RtbfRefStatus, RtbfStatus } from "./rtbfStatus.model";

class RtbfStatusController {

    userRtbfStatus: RtbfStatus;
    existingRtbfStatus: boolean = false;
    existingRtbfStatusDateRequested: string | null = null;
    submitted: boolean = false;
    userId = null;
    unauthorizedAppStatuses = ['PLC', 'REJ', 'ACT', 'REM', 'APD', 'AWL', 'INA'];
    canDeleteData: boolean = false;

    static $inject = ['$scope', 'dialogs', 'Auth', 'RtbfStatus', 'applicationStatus'];
    constructor(private $scope, private dialogs, private Auth, private RtbfStatus, applicationStatus){
        this.userId = Auth.user.userId;
        this.canDeleteData = !this.unauthorizedAppStatuses.includes(applicationStatus.status);

        if(this.canDeleteData){
            this.init();
        }
    }

    submit(){
        this.$scope.$broadcast('submitted', true);
        this.submitted = true;

        this.dialogs.confirm(
            'Confirm',
            'You are requesting to permanently delete your data. Are you sure?'
        ).result
        .then(() => {
            this.RtbfStatus.save({ applicationId: this.Auth.user.roleDetails.applicationId }, this.userRtbfStatus).$promise
            .then(() => {
                this.dialogs.notify('Success', 'Your request to delete your data is confirmed and will be validated soon.');
                this.init();
            }, () => {
                this.dialogs.error('Error', 'Unable to request data deletion. Please try again later.');
            });
        })
    }

    private init(){
        const applicationId = this.Auth.user.roleDetails.applicationId;

        this.userRtbfStatus = {
            requestingUserId: this.userId,
            requestedUserId: this.userId,
            statusId: RtbfRefStatus.Requested,
            dateRequested: new Date(Date.now()),
            reason: ''
        };

        this.RtbfStatus.get({ applicationId: applicationId })
            .$promise
            .then((request) => {
                if(request?.rtbfStatusId && request?.requestedUserId === this.userId){
                    this.userRtbfStatus = request;
                    this.existingRtbfStatus = true;
                    this.existingRtbfStatusDateRequested = new Date(request?.dateRequested).toLocaleDateString();
                }
            });
    }
}

angular
    .module('app')
    .controller('RtbfStatusController', RtbfStatusController);